module.exports = __webpack_public_path__ + "img/Group_28005@2x.ba41e635.png";